import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { finalize, take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../../core';
import { ClassificacaoFaturamentoCrudHttpService } from '../../../../home/classificacao-faturamento/services';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';

@Component({
  selector: 'sgt-novo-classificacao-faturamento-multiselect',
  templateUrl: './novo-classificacao-faturamento-multiselect.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(
        () => NovoClassificacaoFaturamentoMultiselectComponent
      ),
      multi: true
    }
  ]
})
export class NovoClassificacaoFaturamentoMultiselectComponent extends CustomControlValueAccessor<
  number[]
> {
  @Input() idsClassificacoesFaturamento: number[];
  @Output() idsClassificacoesFaturamentoChange = new EventEmitter<number[]>();

  settings: IMultiSelectSettings = {
    placeholder: 'Selecione as classificações',
    plural: 'Classificações',
    singular: 'Classificação',
    searchEmptyResultMessage: 'Nenhuma classificação encontrada',
    showFooter: false
  };

  options: IOption[] = [];

  constructor(
    private messageService: MessageService,
    private classificacaoFaturamentoCrudHttpService: ClassificacaoFaturamentoCrudHttpService
  ) {
    super();
  }

  firstOpened(isFirstOpened: boolean): void {
    if (isFirstOpened && this.options.length === 0) {
      this.create();
    }
  }

  private create() {
    this.definirCarregando(true);

    this.classificacaoFaturamentoCrudHttpService
      .search()
      .pipe(take(1), finalize(() => this.definirCarregando(false)))
      .subscribe(
        (entities) => {
          if (entities) {
            const opt = entities.map((entity) => ({
              id: entity.id,
              label: entity.nome,
              isChecked: this.value ? this.value.includes(entity.id) : false
            }));

            this.options = [{ id: 0, label: 'SEM CLASSIFICAÇÃO' }, ...opt];
          }
        },
        (error: ApiError) => {
          this.messageService.error(
            error.message,
            'Erro ao pesquisar as Classificações de Faturamentos',
            error
          );
        }
      );
  }

  onSearch() {
    this.idsClassificacoesFaturamentoChange.emit(
      this.idsClassificacoesFaturamento
    );
  }

  onSelectionChange() {
    this.emitChange(this.idsClassificacoesFaturamento);
    this.markAsTouched();
  }

  protected updateValue(newValue: number[] | null): void {
    const ids = newValue ?? [];
    if (ids.length > 0 && this.options.length === 0) {
      this.create();
      return;
    }
    if (this.options.length > 0) {
      this.options.forEach((o) => {
        o.isChecked = ids.includes(o.id);
      });
    }
  }

  private definirCarregando(carregando: boolean): void {
    this.settings = { ...this.settings, isLoading: carregando };
  }

}
